export class DepartmentList {
    id?:number
    name: string
    shortName: string
    code: string
    branch: string
}